import { defineMessages } from 'react-intl';

export const messages: {
	moreMenuTriggerLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	moreMenuTriggerLabel: {
		id: 'navigation.global-more-menu.trigger-label',
		defaultMessage: 'More',
		description: 'Default label text for the global more menu trigger button',
	},
});
